/* ============================================================
   Featured Flavor of the Month — Swiper Initialisation
   File: assets/section-featured-flavor.js
   Arrows only — no pagination.
   ============================================================ */

(function () {
  'use strict';

  const SWIPER_VERSION = '11.1.4';
  const CDN_BASE       = `https://cdn.jsdelivr.net/npm/swiper@${SWIPER_VERSION}`;

  const loadStyle = (href) => {
    if (document.querySelector(`link[href="${href}"]`)) return;
    const el  = document.createElement('link');
    el.rel    = 'stylesheet';
    el.href   = href;
    document.head.appendChild(el);
  };

  const loadScript = (src) =>
    new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) return resolve();
      const el   = document.createElement('script');
      el.src     = src;
      el.async   = true;
      el.onload  = resolve;
      el.onerror = () => reject(new Error(`Failed to load ${src}`));
      document.head.appendChild(el);
    });

  const initSwiper = (sectionEl) => {
    const swiperEl = sectionEl.querySelector('.featured-flavor-swiper');
    if (!swiperEl) return;

    const slides = swiperEl.querySelectorAll('.swiper-slide');
    if (slides.length < 2) return;

    if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);

    /* global Swiper */
    new Swiper(swiperEl, {
      loop:       true,
      speed:      420,
      grabCursor: true,
      keyboard: {
        enabled:        true,
        onlyInViewport: true,
      },
      a11y: {
        prevSlideMessage: 'Previous product image',
        nextSlideMessage: 'Next product image',
      },
      navigation: {
        prevEl: sectionEl.querySelector('.featured-flavor-prev'),
        nextEl: sectionEl.querySelector('.featured-flavor-next'),
      },
    });
  };

  const boot = async () => {
    const sections = document.querySelectorAll('.featured-flavor');
    if (!sections.length) return;
    try {
      loadStyle(`${CDN_BASE}/swiper-bundle.min.css`);
      await loadScript(`${CDN_BASE}/swiper-bundle.min.js`);
      sections.forEach(initSwiper);
    } catch (err) {
      console.warn('[Featured Flavor] Swiper failed to load:', err);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const sectionEl = e.target.querySelector('.featured-flavor');
    if (!sectionEl) return;
    typeof Swiper !== 'undefined' ? initSwiper(sectionEl) : boot();
  });
})();